import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to the console
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '20px', textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ color: '#172B4D' }}>Something went wrong</h2>
          <p style={{ color: '#6B778C', marginBottom: '20px' }}>
            The application encountered an error. Please try refreshing the page.
          </p>
          <details style={{ 
            whiteSpace: 'pre-wrap', 
            backgroundColor: '#F4F5F7', 
            padding: '10px', 
            borderRadius: '3px',
            textAlign: 'left',
            marginBottom: '20px'
          }}>
            <summary style={{ cursor: 'pointer', color: '#0052CC', fontWeight: 'bold' }}>
              Show error details
            </summary>
            <p style={{ color: '#FF5630', marginTop: '10px' }}>
              {this.state.error && this.state.error.toString()}
            </p>
            <p style={{ color: '#172B4D', marginTop: '10px' }}>
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </p>
          </details>
          <button 
            onClick={() => window.location.reload()} 
            style={{
              backgroundColor: '#0052CC',
              color: 'white',
              border: 'none',
              borderRadius: '3px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 